import useValidation from "../../hooks/useValidation";
import { useEffect, useState } from "react";
import { format, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { DateType, DateTypesignature } from "../../static/types/commonTypes/dateType";
import dateValidationSchema from "../../utils/validation/dateValidationSchema";
import FieldDescription from "../tools/FieldDescription";
import dateValidationSchemasignature from "../../utils/validation/datesignatureSchema";

type datePropssignature = {
    dateLabelsignature: string,
    checkedsignature: boolean,
    mandatorysignature: boolean,
    datesignature: DateTypesignature,
    changeDatesignature: (date: Partial<DateTypesignature>) => void,
    onValidationChangesignature: (isValid: boolean) => void,
};

export default function DateSignature({
    checkedsignature,
    datesignature,
    dateLabelsignature,
    mandatorysignature,
    changeDatesignature,
    onValidationChangesignature
}: datePropssignature) {

    const { errors, isValid: isDataValid } = useValidation(datesignature, dateValidationSchemasignature);

    useEffect(() => {
        onValidationChangesignature(isDataValid);
    }, [isDataValid, onValidationChangesignature]);

    const [selectedDatesignature, setSelectedDatesignature] = useState<string>("");
    const [selectedEffectiveDate, setSelectedEffectiveDate] = useState<string>("");

    useEffect(() => {
        if (datesignature.datesignature) {
            const parsedDate = parse(datesignature.datesignature, "dd/MM/yyyy", new Date());
            setSelectedDatesignature(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
        if (datesignature.effectiveDatesignature) {
            const parsedDate = parse(datesignature.effectiveDatesignature, "dd/MM/yyyy", new Date());
            setSelectedEffectiveDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [datesignature]);

    const handleDecisionDateChangesignature = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = e.target.value;
    if (!inputDate) {
        setSelectedDatesignature("");
        changeDatesignature({ datesignature: "" });
        return;
    }

    const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());

    if (!isValid(parsedDate)) {
        setSelectedDatesignature("");
        changeDatesignature({ datesignature: "" });
        return;
    }

    const formattedDate = format(parsedDate, "dd/MM/yyyy");
    setSelectedDatesignature(inputDate);
    changeDatesignature({ datesignature: formattedDate });
};


const handleEffectiveDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputDate = e.target.value;
    if (!inputDate) {
        setSelectedEffectiveDate("");
        changeDatesignature({ effectiveDatesignature: "" });
        return;
    }

    const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());

    if (!isValid(parsedDate)) {
        setSelectedEffectiveDate("");
        changeDatesignature({ effectiveDatesignature: "" });
        return;
    }

    const formattedDate = format(parsedDate, "dd/MM/yyyy");
    setSelectedEffectiveDate(inputDate);
    changeDatesignature({ effectiveDatesignature: formattedDate });
};


    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (
        <div className="container p-4">
            <div className="row mb-2">
                <label htmlFor="datesignature" className="col-4 col-form-label  mb-1" style={{marginRight: '-180px'}}>
                    {dateLabelsignature} {mandatorysignature && <strong className="text-danger">*</strong>}
                </label>

                <div className="col-6">
                    <input
                        className={`description-input form-control ${(checkedsignature && errors.datesignature) ? 'is-invalid' : ''}`}
                        type="date"
                        id="datesignature"
                        value={selectedDatesignature}
                        onChange={handleDecisionDateChangesignature}
                        onClick={() => openDatePicker("datesignature")}
                        placeholder="JJ/MM/AAAA"
                    />
                    {(checkedsignature && errors.datesignature) && <div className="invalid-feedback">{errors.datesignature}</div>}
                    <FieldDescription description="Format : JJ/MM/AAAA" />
                </div>

                {('effectiveDate' in datesignature) && (
                    <>
                        <label htmlFor="effectiveDate" className="col-4 col-form-label fw-bold mb-1">
                            Date d’effet
                        </label>
                        <div className="col-6">
                            <input
                                className="form-control"
                                type="date"
                                id="effectiveDate"
                                value={selectedEffectiveDate}
                                onChange={handleEffectiveDateChange}
                                onClick={() => openDatePicker("effectiveDate")}
                                placeholder="JJ/MM/AAAA"
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
